
import React from "react";
import { toast } from "sonner";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

import { CampaignForm } from "./modal/CampaignForm";
import { CampaignFormData } from "./modal/CampaignFormSchema";
import { ScrollArea } from "@/components/ui/scroll-area";

// Legacy Campaign type for backward compatibility - now matching the database structure
export type Campaign = {
  id: string;
  name: string;
  type: string;
  product: "cashback" | "referral";
  value: number;
  start_date: string; // Changed from startDate to match database
  end_date: string;   // Changed from endDate to match database
  status: "active" | "scheduled" | "completed" | "draft" | "cancelled";
  description?: string;
  minimum_spent_amount?: number;
  cashback_template_id?: string;
  max_coupons_per_customer?: number;
  delay_days?: number;
  // Campos para customização de cashback
  use_custom_cashback?: boolean;
  custom_cashback_percentage?: number;
  custom_cashback_multiplier?: number;
  custom_cashback_expiration_days?: number;
};

interface CampaignModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSave: (campaign: CampaignFormData, action?: 'draft' | 'publish') => void;
  campaign?: Campaign;
}

export function CampaignModal({ open, onOpenChange, onSave, campaign }: CampaignModalProps) {
  const isEditing = !!campaign;
  
  const handleSubmit = (values: CampaignFormData, action: 'draft' | 'publish' = 'draft') => {
    try {
      onSave(values, action);
      onOpenChange(false);
    } catch (error) {
      toast.error("Erro ao salvar campanha");
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[700px] max-h-[90vh] p-0">
        <DialogHeader className="px-6 py-4 border-b bg-gray-50/50">
          <DialogTitle className="text-xl font-semibold">
            {isEditing ? "Editar Campanha" : "Nova Campanha"}
          </DialogTitle>
        </DialogHeader>
        
        <div className="flex-1 overflow-hidden">
          <ScrollArea className="h-[calc(90vh-80px)]">
            <div className="p-6">
              <CampaignForm 
                onSubmit={handleSubmit} 
                onCancel={() => onOpenChange(false)} 
                campaign={campaign}
                isEditing={isEditing}
              />
            </div>
          </ScrollArea>
        </div>
      </DialogContent>
    </Dialog>
  );
}
